<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Itinerari-esperienze/03_Serre/03_2_SerraSanBruno-Pizzo/03_2_Certosa_SantoStefano.jpg">
<div class="content">
    <h1>Serre</h1>
    <h3>Serra San Bruno</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a>Parco Regionale delle Serre</a> > <a class="active">Serra San Bruno</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div class="row schedaItinerario">
    <h2>Serra San Bruno – Soriano - Lago Angitola – Pizzo Calabro</h2>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <img class="itinerario-foto" src="../../../assets/images/Itinerari-esperienze/03_Serre/03_2_SerraSanBruno-Pizzo/03_2_Certosa_SantoStefano.jpg">
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div id="map" class="mapInfo"></div>
    </div>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <p class="testoItinerario">
            Il percorso parte da Serra San Bruno, il paese della monumentale Certosa di Santo Stefano, e si dirige verso il Tirreno sulla SS182. 
            Raggiunto il centro di Sorianello da cui si gode la vista sulla Valle dei Mulini, si raggiunge Soriano dove si possono apprezzare 
            i magnifici resti del Complesso monumentale di San Domenico. Da qui si riparte e si procede verso San Nicola da Crissa, 
            il “balcone delle Calabrie” da cui si gode un panorama immenso che nei giorni di maggiore chiarore consente di vedere l’intera costa calabra sul Tirreno, 
            fino alle isole Eolie, allo Stretto di Messina e all’Etna.
            <br>
            <br>
            Da qui inizia la discesa verso L’Oasi naturalistica del Lago Angitola che rientra nel territorio del Parco Regionale delle Serre. 
            Dichiarata “zona umida di valore internazionale” è un posto davvero incantevole che regala sensazioni che lasciano il segno, 
            per i colori che il lago assume nelle diverse ore del giorno e per le tante specie di uccelli che lo popolano, dal Falco pescatore a quello di palude, 
            dall’Airone bianco a quelli rosso e cenerino, fino ai cormorani. Lungo le rive si può percorrere un piacevole tracciato ciclopedonale con attraversamento 
            del fiume su di un ponte in legno, immersi in un paesaggio lacustre magnifico.
            <br>
            <br>
            Superato il Lago si procede sulla SS110 in direzione di Pizzo Calabro che si raggiunge percorrendo circa 12 Km pressoché pianeggianti. 
            La città che ha origini che risalgono alla Magna Grecia, si trova sulla magnifica Costa degli Dei ed è sovrastata dal Castello aragonese 
            dove fu tenuto prigioniero e fu ucciso Gioacchino Murat, le cui spoglie riposano nella Chiesa di San Giorgio.
        </p>
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div class="row">
            <div class="col">
                <h5>Percorso:</h5>
            </div>
            <div class="col right">
                <h5> in bici e a piedi</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Difficoltà:</h5>
            </div>
            <div class="col right">
                <h5>difficile</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Lunghezza:</h5>
            </div>
            <div class="col right">
                <h5>61,6 Km</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Giorni:</h5>
            </div>
            <div class="col right">
                <h5>1</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Salita:</h5>
            </div>
            <div class="col right">
                <h5>910 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Discesa:</h5>
            </div>
            <div class="col right">
                <h5>1640 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di Partenza:</h5>
            </div>
            <div class="col right">
                <h5>Serra San Bruno</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di arrivo:</h5>
            </div>
            <div class="col right">
                <h5>Pizzo Calabro</h5>
            </div>
        </div>
        <div class="divider"></div>
    </div>
</div>
<br>
<br>
<div class="divider2">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-9 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco Regionale delle Serre.</p>
    </div>
    <div class="col-3 col-xl-1">
        <img style="width: 65%;" src="../../../assets/images/Logo-Parco-1024x1024.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Serra San Bruno</h1>
                        <a (click)="goToLorica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Girifalco</h1>
                        <a (click)="goToArte()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider2">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>
